import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstanse";

export interface CancelRequest {
    bl_no: string;
    s_a_mobile?: string;
}

export interface CancelResponse {
    statusCode: number;
    message: string;
}

export const usePutTrackingCancel = (
    successCallback?: (data: CancelResponse) => void,
): UseMutationResult<CancelResponse, Error, CancelRequest, unknown> => {
    const queryClient = useQueryClient();

    return useMutation<CancelResponse, Error, CancelRequest>({
        mutationFn: async (orderData: CancelRequest) => {
            const response = await axiosInstance.put(enum_api_uri.tracking_cancel, orderData);
            return response.data;
        },
        onSuccess: data => {
            successCallback?.(data);
            queryClient.invalidateQueries({ queryKey: ["useGetTrackingDetail"] });
        },
    });
};
